import _ = require('underscore');
import { Messages } from '../../../../../codegen/Localize';
import { IDatasourceActions } from '../../../../../datasource/ServerApi/types/IDatasourceActions';
import { FeatureFlags } from '../../../../../ts/FeatureFlags';
import { IAccelerationTaskInfo } from '../../../../../ts/models/IAccelerationTaskInfo';
import { IWorkbookActions } from '../../../../../workbook/ServerApi/types/IWorkbookActions';
import { adminDisallowAcceleration } from '../../../../actions/spaces/dataAcceleration/DataAccelerationTaskMenuAction';
import { AppState } from '../../../../state/AppState';
import { currentUserIsAdmin } from '../../../../utils/MixedContentHelpers';
import { EntityActionNames, IEntityAction } from '../IEntityAction';

export const AdminDisallowAccelerationAction: IEntityAction<IAccelerationTaskInfo, IWorkbookActions | IDatasourceActions> = {
  name: EntityActionNames.AdminDisallowDataAcceleration,
  translateName: Messages.accelerateDisAllow_action,
  isVisible: isVisible,
  isClickable: isClickable,
  createReduxAction: adminDisallowAcceleration
};

function isClickable(
  availableActions: IWorkbookActions | IDatasourceActions,
  tasks: IAccelerationTaskInfo[],
  state: AppState
): boolean {
  return FeatureFlags.accelerationSiteAdminUIEnabled
          && currentUserIsAdmin(state)
          && _.any(tasks, (task) => !task.adminDisallowed);
}

function isVisible(
  tasks: IAccelerationTaskInfo[],
  state: AppState,
  availableActions: IWorkbookActions | IDatasourceActions,
): boolean {
  return FeatureFlags.accelerationSiteAdminUIEnabled
          && currentUserIsAdmin(state);
}
